// Generated by scripts/update-version.js — do not edit by hand
export const APP_VERSION = "2026.8.26.1456";
export const APP_BUILD_DATE = "2026-08-26T17:56:42.726Z";
